module.exports = __webpack_public_path__ + "img/chemical_zixun_img.646d4ba7.png";